import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import SelectBox from '../../shared/select-boxes/SelectBox';
import IndustriesPopup from './IndustriesPopup';
import VideoComponent from '../../shared/VideoComponent';
import ButtonBack from '../../shared/buttonComponents/ButtonBack';
import { useHistory } from 'react-router-dom';
import IndustriesPopupOther from './IndustriesPopupOther';
import IndustriesPopupLetters from './IndustryPopupLetters';

export const IndustryPage: FC = () => {
  const {
    changeStep,
    updateStepData,
    staticData
  } = useWizard();

  const [selected, setSelected] = useState<string>('');
  const pageRef = useRef(null);

  const industrySubIndustriesMap = useMemo(() => {
    return staticData.industries.reduce((acc, industry) => {
      const item = {
        name: industry.name,
        risk: industry.risk,
        selected: false
      };

      if (acc[industry.category]) {
        acc[industry.category].push(item);
      } else {
        acc[industry.category] = [item];
      }

      return acc;
    }, {
      'eCommerce': [],
      'Financial Services': [],
      'Travel': [],
      'Online Services': [],
      'Gaming': [],
      'Retail': [],
      'CBD': [],
      'Partner': [],
      'Other': []
    } as { [key: string]: { name: string, risk: string, selected: boolean }[] });
  }, [staticData.industries]);

  const handleSelected = useCallback((subIndustry) => {
    updateStepData({
      mainIndustry: selected || '',
      industryRisk: subIndustry?.risk || '',
      subIndustry: subIndustry?.name || '',
    });

      changeStep(WizardStep.LICENCE_TYPE);
  }, [selected, updateStepData, changeStep]);

  const handleSelect = useCallback((mainIndustry) => {
    if (pageRef.current) {
      // @ts-ignore
      pageRef.current.scrollTo(0, 0);
    }
    setSelected(mainIndustry);
  }, [setSelected]);

  let history = useHistory();
  useEffect(() => {
    return () => {
      if (history.action === 'POP') {

        changeStep(WizardStep.CONTINENT);
      }
    };
  });

  return (
    <Layout refE={pageRef}>
      <div className="industry-page-container">
        {}
        {selected === 'Other'
          ?
          (<IndustriesPopupOther
            industry={selected}
            industries={staticData.industries}
            industriesList={industrySubIndustriesMap[selected] || []}
            onClose={() => setSelected('')}
            onSubmit={handleSelected}
          />)
          :
            selected === 'eCommerce'
              ?
            (<IndustriesPopupLetters
              industry={selected}
              industriesList={industrySubIndustriesMap[selected] || []}
              onClose={() => setSelected('')}
              onSubmit={handleSelected}
            />)
          :
          selected &&
          (<IndustriesPopup
            industry={selected}
            industriesList={industrySubIndustriesMap[selected] || []}
            onClose={() => setSelected('')}
            onSubmit={handleSelected}
          />
        )}
        <div className="industry-page-right-mobile">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/industry.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/industry.png`}
          />
        </div>

        <div className="industry-page-left">
          <div className="secondary-title">OK, Let's start</div>
          <div className="main-title">What's your<br/> industry?</div>
          <div className="industry-page-list">
            {Object.keys(industrySubIndustriesMap).map((industry) => (
              <SelectBox
                key={industry}
                onClick={() => handleSelect(industry)}
                icon={`industries/${industry.toLocaleLowerCase().replace(/\\s/g, '-')}`}
                title={industry}
              />
            ))}
          </div>

          <div className='industry-page-button'>
            <ButtonBack
              disabled={false}
              onClick={() => changeStep(WizardStep.CONTINENT)}
              title="Back"
            />
          </div>

        </div>

        <div className="industry-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/industry.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/industry.png`}
          />
        </div>
      </div>
    </Layout>
  );
};
